const ADD13MONTHS = 13 * 30 * 24 * 60 * 60 * 1000; // Get 13 months in milliseconds

export const setWithExpiry = (key, value, ttl) => {
  const now = new Date().getTime();

  if (!ttl) {
    ttl = now + ADD13MONTHS;
  }

  const item = {
    value: value,
    expiry: ttl,
  };
  try {
    localStorage.setItem(key, JSON.stringify(item));
  } catch (e) {
    console.log(e);
  }
};

export const getWithExpiry = (key) => {
  try {
    const localItem = localStorage.getItem(key);
    // No items ? Return null
    if (!localItem) {
      return null;
    }
    const item = JSON.parse(localItem);
    const now = new Date().getTime();

    // TTL is over ? Return null
    if (now > item.expiry) {
      // We've reached TTL, so let's cleanup the Storage
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    console.log(e);
    return null;
  }
};
